<div class="flex justify-content-center">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="flex flex-column mb-4 align-items-center">
      <div class="text-900 text-xl font-bold mb-2">
        {{ 'VERIFICATION.newPassword' | translate }}
      </div>
      {{ 'VERIFICATION.enterNewPassword' | translate }}
      <span class="text-600 font-medium"></span>
    </div>
    <div class="flex flex-column">
      <!-- Password Field -->
      <div class="mb-4">
        <span class="p-input-icon-left w-full">
          <i class="pi pi-lock z-2"></i>
          <p-password
            [feedback]="true"
            formControlName="password"
            placeholder="{{ 'COMMON.password' | translate }}"
            styleClass="w-full"
            [inputStyle]="{ paddingLeft: '2.5rem' }"
            inputStyleClass="w-full md:w-25rem"
            [toggleMask]="true"
            [ngClass]="{
              'custom-invalid-class': password?.invalid && (password?.dirty || password?.touched)
            }"
          >
            <ng-template #footer>
              <p-divider></p-divider>
              <div class="mt-0" style="line-height: 1.5">
                <div class="password-validation">
                  <img [src]="'assets/img/icons/' + errorIcons.minLength + '.svg'" alt="" />
                  <p [ngClass]="{ 'error-text': password?.hasError('minlength') }">
                    {{ 'VERIFICATION.min8Characters' | translate }}
                  </p>
                </div>
                <div class="password-validation">
                  <img [src]="'assets/img/icons/' + errorIcons.number + '.svg'" alt="" />
                  <p [ngClass]="{ 'error-text': password?.hasError('atLeastOneNumber') }">
                    {{ 'VERIFICATION.atLeastOneNumeric' | translate }}
                  </p>
                </div>
                <div class="password-validation">
                  <img [src]="'assets/img/icons/' + errorIcons.upperAndLower + '.svg'" alt="" />
                  <p [ngClass]="{ 'error-text': password?.hasError('letterAndSymbol') }">
                    {{ 'VERIFICATION.atLeastOneLowerAndUppercase' | translate }}
                  </p>
                </div>
                <div class="password-validation">
                  <img [src]="'assets/img/icons/' + errorIcons.specialCharacter + '.svg'" alt="" />
                  <p [ngClass]="{ 'error-text': password?.hasError('atLeastOneSpecialCharacter') }">
                    {{ 'VERIFICATION.atLeastOneSpecialCharacter' | translate }}
                  </p>
                </div>
              </div>
            </ng-template>
          </p-password>
        </span>
      </div>
      <!-- Confirm Password Field -->
      <div class="mb-4">
        <span class="p-input-icon-left w-full">
          <i class="pi pi-lock z-2"></i>
          <p-password
            [feedback]="true"
            formControlName="password_confirmation"
            placeholder="{{ 'COMMON.confirmPassword' | translate }}"
            styleClass="w-full"
            [inputStyle]="{ paddingLeft: '2.5rem' }"
            inputStyleClass="w-full md:w-25rem"
            [toggleMask]="true"
            [ngClass]="{
              'custom-invalid-class':
                (confirmPassword?.invalid &&
                  (confirmPassword?.dirty || confirmPassword?.touched)) ||
                form.hasError('notMatched')
            }"
          >
            <ng-template #footer>
              <div class="mt-0" style="line-height: 1.5">
                <div class="password-validation">
                  <img [src]="'assets/img/icons/' + errorIcons.required + '.svg'" alt="" />
                  <p [ngClass]="{ 'error-text': confirmPassword?.hasError('required') }">
                    {{ 'VERIFICATION.passwordConfirmationRequired' | translate }}
                  </p>
                </div>
                <div class="password-validation">
                  <img [src]="'assets/img/icons/' + errorIcons.notMatched + '.svg'" alt="" />
                  <p [ngClass]="{ 'error-text': form.hasError('notMatched') }">
                    {{ 'VERIFICATION.passwordsDoNotMatch' | translate }}
                  </p>
                </div>
              </div>
            </ng-template>
          </p-password>
        </span>
      </div>
      <!-- Buttons -->
      <div class="flex flex-wrap gap-2 justify-content-between">
        <app-button
          label="{{ 'COMMON.cancel' | translate }}"
          [routerLink]="['/']"
          class="flex-auto"
          [fullWidth]="true"
          buttonStyle="outlined"
        ></app-button>
        <app-button
          label="{{ 'COMMON.submit' | translate }}"
          type="submit"
          class="flex-auto"
          [fullWidth]="true"
          [disabled]="form.invalid"
        ></app-button>
      </div>
    </div>
  </form>
</div>
